<template>
  <div class="d-flex fill-height flex-column flex-fill p-relative card__wrapper">
    <v-container fluid class="pa-0 ma-0" v-if="!itemLote['blBaixa'] && !itemLote['blCarencia']">
      <v-row class="ma-0 pa-0 no-grace-and-casualty__row" />
    </v-container>
    <v-card
      flat
      height="100%"
      width="100%"
      class="card-com-lote-alocado"
      :class="[{
        'grace-period': itemLote['blCarencia'] && !itemLote['blBaixa'],
        'casualty': itemLote['blBaixa'] && !itemLote['blCarencia'],
        'grace-and-casualty': itemLote['blBaixa'] && itemLote['blCarencia']
      }]"
    >
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-row
            v-show="itemLote['blCarencia'] && !itemLote['blBaixa']"
            align="center"
            v-on="on"
            class="ma-0 grace-period__row px-4"
          >
            <v-icon left small color="white">fas fa-prescription-bottle-alt</v-icon>
            <span>Lote em carência</span>
          </v-row>
        </template>
        <v-container fluid class="pa-0">
          <v-row class="ma-0 py-1">
            <span class="tooltip__text-bold">Lote em período de carência</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Medicamento:</span>
            <span class="tooltip__text-bold pl-1">{{ (itemLote && itemLote["nmFarmaco"]) || "" }}</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Data Final:</span>
            <span
              class="tooltip__text-bold pl-1"
            >{{ itemLote ? $options.filters.datetimeFormat(itemLote["dtCarencia"]) : "" }}</span>
          </v-row>
        </v-container>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-row
            v-show="itemLote['blBaixa'] && !itemLote['blCarencia']"
            align="center"
            v-on="on"
            class="ma-0 casualty__row px-4"
          >
            <v-icon left small color="white">fas fa-book-dead</v-icon>
            <span>Lote com mortalidade</span>
          </v-row>
        </template>
        <v-container fluid class="pa-0">
          <v-row class="ma-0 py-1">
            <span class="tooltip__text-bold">Lote com baixa informada</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Nº de mortes:</span>
            <span class="tooltip__text-bold">{{ (itemLote && itemLote["qtBaixa"]) || "" }}</span>
          </v-row>
        </v-container>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-row
            v-show="itemLote['blBaixa'] && itemLote['blCarencia']"
            align="center"
            v-on="on"
            class="ma-0 grace-and-casualty__row px-4"
          >
            <v-icon left small color="white">fas fa-prescription-bottle-alt</v-icon>
            <v-icon left small color="white">fas fa-book-dead</v-icon>
            <span>Lote com carência e mortalidade</span>
          </v-row>
        </template>
        <v-container fluid class="pa-0">
          <v-row class="ma-0 py-1">
            <span class="tooltip__text-bold">Lote com baixa e carência informada</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Nº de mortes:</span>
            <span class="tooltip__text-bold">{{ (itemLote && itemLote["qtBaixa"]) || "" }}</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Medicamento:</span>
            <span class="tooltip__text-bold pl-1">{{ (itemLote && itemLote["nmFarmaco"]) || "" }}</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Data Final:</span>
            <span
              class="tooltip__text-bold pl-1"
            >{{ itemLote ? $options.filters.datetimeFormat(itemLote["dtCarencia"]) : "" }}</span>
          </v-row>
        </v-container>
      </v-tooltip>
      <v-layout row justify-start ma-0 px-2 pt-2>
        <span class="label-produtor">Produtor</span>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              depressed
              icon
              x-small
              color="#BDCCCA"
              class="card-actions__btn info"
            >
              <v-icon x-small color="white">fas fa-info</v-icon>
            </v-btn>
          </template>
          <span>
            <span class="title-tooltip">Lote:</span>
            <span class="value-tooltip pl-1">
              {{
              itemLote.loteProducao.nrLoteControle
              }}
            </span>
            <br />
            <span class="title-tooltip">Extensionista:</span>
            <span class="value-tooltip pl-1">
              {{
              (itemLote.extensionista && itemLote.extensionista.nmPessoa) || ""
              }}
            </span>
            <br />
            <span class="title-tooltip">Cidade:</span>
            <span class="value-tooltip pl-1">
              {{
              itemLote.nmMunicipio
              }}
            </span>
          </span>
        </v-tooltip>
      </v-layout>
      <v-layout row justify-start pb-2>
        <v-flex lg11 pl-5>
          <span class="nome-produtor">{{ itemLote.loteProducao.jsonProdutor.nmProdutor }}</span>
        </v-flex>
      </v-layout>
      <v-row class="ma-0 px-4 infos-lote">
        <v-col cols="6" class="pa-0 py-2">
          <v-row class="ma-0 py-1">
            <span class="label-card-dados-lote">Alocados</span>
            <span class="value-card-dados-lote pl-1">
              {{
              itemLote.qtAnimaisAlocados
              }}
            </span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="label-card-dados-lote">Gênero</span>
            <span class="value-card-dados-lote pl-1">
              {{
              itemLote.dsTipoSexo
              }}
            </span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="label-card-dados-lote">Tipo</span>
            <span class="value-card-dados-lote pl-1">
              {{
              itemLote.loteProducao.jsonUnidadeExploracao.csTipoUnidadeExploracao
              }}
            </span>
          </v-row>
        </v-col>
        <v-col cols="6" class="pa-0 py-1">
          <v-row justify="end" class="ma-0 py-1">
            <span class="label-card-dados-lote">Distância</span>
            <span class="value-card-dados-lote pl-1">
              {{
              itemLote.distanciaPlanta.nrValor
              }}
            </span>
            <span class="value-card-dados-lote pl-1">
              {{
              itemLote.distanciaPlanta.dsTipo
              }}
            </span>
          </v-row>
          <v-row justify="end" class="ma-0 py-1">
            <span class="label-card-dados-lote">Alojamento</span>
            <span class="value-card-dados-lote pl-1">{{ itemLote.nrDiasAlojado }} d</span>
          </v-row>
          <v-row justify="end" class="ma-0 py-1">
            <span class="label-card-dados-lote">Peso</span>
            <span class="value-card-dados-lote pl-1">{{ itemLote.nrPesoDia }} kg</span>
          </v-row>
        </v-col>
      </v-row>
      <v-layout row justify-center pl-5 pb-2 pr-5 mt-2>
        <v-flex lg12 v-if="itemCheckList.dtConfirmacaoProdutor != null">
          <DialogDadosChecKList :checkList="itemCheckList">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="#2bc1b6" class="btn-exibir-checklist">Visualizar Checklist</v-btn>
            </template>
          </DialogDadosChecKList>
        </v-flex>
        <v-flex lg12 v-else>
          <v-btn disabled large block class="btn-sem-checklist">Checklist não preenchido</v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { daysBetweenDates } from "@/filters/utils";

import DialogDadosChecKList from "@/modules/programacaoAbate/components/DialogDadosChecKList";
import moment, { ISO_8601 } from "moment";

export default {
  name: "CardItemLoteAlocadoProgramacao",
  components: {
    DialogDadosChecKList,
  },
  props: {
    itemData: {
      type: Object,
      default: {},
    },
    itemPlanta: {
      type: Object,
      default: {},
    },
    itemLote: {
      type: Object,
      default: {},
    },
  },
  filters: {
    datetimeFormat: (value, format = "DD/MM/Y") => {
      const parsedDate = moment(value, ISO_8601);
      if (!parsedDate.isValid()) return "";
      return parsedDate.format(format);
    },
  },
  computed: {
    ...mapState("programacaoAbate", ["listCheckListAlocados"]),
    blLoteConfirmado: {
      get() {
        return this.itemLote.blConfirmado;
      },
      set(val) {
        this.ActionChangeLoteConfirmado({
          valueLote: this.itemLote,
          blLoteConfirmado: val,
        });
      },
    },
    itemCheckList() {
      let item = this.listCheckListAlocados.find(
        (x) =>
          x.cdProgramacaoAbateAlocado == this.itemLote.idProgramacaoAbateAlocado
      );
      if (item != undefined) {
        return item;
      }
      return { dtConfirmacaoProdutor: null };
    },
  },
  methods: {
    ...mapActions("programacaoAbate", [
      "ActionLoadDistanciaPlantaAbateEstabelecimento",
      "ActionChangeLoteConfirmado",
    ]),
    daysBetweenDates,
    showInfosChecklist(itemLote) {
      return;
    },
  },
};
</script>

<style lang="scss">
.btn-exibir-checklist {
  width: 100%;
  background-color: rgb(43, 193, 182);
  border-color: rgb(43, 193, 182);
  color: white !important;
  border-radius: 4px;
  opacity: 1;
}

.btn-exibir-checklist,
.btn-sem-checklist {
  min-height: 44px !important;
  height: auto !important;

  .v-btn__content {
    white-space: normal !important;
    word-break: break-word !important;
    word-wrap: normal !important;
    width: 100% !important;
  }
}
</style>
